const GET_SECONDARY_APPROVER = 'GET_SECONDARY_APPROVER';
const SET_SECONDARY_APPROVER = 'SET_SECONDARY_APPROVER';

export {
    GET_SECONDARY_APPROVER,
    SET_SECONDARY_APPROVER
};